import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import DostepTable from "./components/DostepTable";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import DostepForm from "./components/DostepForm";
import TopIf from "../../../componentsTopsa/if/TopIf";
import UzytownicyService from "./DostepService";
import ReactNotify from 'react-notify';
import DostepPasswordForm from "./components/DostepPasswordForm";
import PracownicyService from "../pracownicy/PracownicyService";
import KierowcyService from "../../konfiguracja/zasobyConfig/kierowcy/KierowcyService";
import ScrollUtilities from "../../../utilities/ScrollUtilities";
import LogowanieService from "../../logowanie/LogowanieService";
import {TopSelect} from "../../../componentsTopsa/selects/TopSelects";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";

export default class DostepContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uzytkownicy: [],
            role: [],
            pokazFormularz: false,
            user: null,
            pokazFormularzHaslo: false,
            kierowcy: [],
            pracownicy: [],

            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            szukanyCiag: '',
            szukanyTyp: null,
            trwaSzukanie: false,
        };
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickZmienHaslo = this.onClickZmienHaslo.bind(this)
        this.onZakmnijForm = this.onZakmnijForm.bind(this)
        this.onClickZapiszHaslo = this.onClickZapiszHaslo.bind(this)
    }

    componentDidMount() {
        this.pobierzUzytkownikow()
        this.pobierzRoleUzytkownikow()
        this.pobierzKierowcow()
        this.pobierzPracownikow()
    }

    pobierzUzytkownikow(strona = this.state.strona, ilosc = this.state.ilosc, szukanyCiag = this.state.szukanyCiag, szukanyTyp = this.state.szukanyTyp) {

        this.setState({trwaSzukanie: true})

        UzytownicyService.getUzytkowicy(strona - 1, ilosc, szukanyCiag, szukanyTyp).then(function (response) {


            if (response.status < 300) {

                let arr = Array.from(response.data.content, item => {
                    let rolestring = ''

                    for (let i = 0; i < item.role.length; i++) {
                        rolestring += item.role[i].rola + ' '
                    }

                    return {
                        roleString: rolestring,
                        ...item
                    }
                })

                this.setState({
                    uzytkownicy: arr,
                    pageable: {
                        first: response.data.first,
                        last: response.data.last,
                        page: response.data.number,
                        size: response.data.size,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages,
                    },
                    trwaSzukanie: false
                })
            } else {
                alert("Wystąpił problem z pobieraniem użytkowników")
                this.setState({trwaSzukanie: false})
            }

        }.bind(this))
            .catch(err => {
                alert("Wystąpił problem z pobieraniem użytkowników")
                this.setState({trwaSzukanie: false})
            })
    }

    pobierzRoleUzytkownikow() {
        UzytownicyService.getRoleUzytkownikow().then(function (response) {
            this.setState({role: response.data})
        }.bind(this))
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcyAktywni().then(function (response) {

            let arr = Array.from(response.data, item => {
                return {
                    ...item,
                    info: item.imie + ' ' + item.nazwisko + ' ' + item.pesel,
                    typId: item.idKi
                }
            })

            this.setState({kierowcy: arr})
        }.bind(this))
    }

    pobierzPracownikow() {
        PracownicyService.getPracownicy().then(function (response) {
            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    info: item.imie + ' ' + item.nazwisko + ' ' + item.email,
                    typId: item.idPr
                }
            })
            this.setState({pracownicy: arr})
        }.bind(this))
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            pokazFormularz: true,
            user: obj
        })
    }

    onClickZapisz(obj, czyEdycja) {

        if (czyEdycja) {
            UzytownicyService.editUzytkownik(obj.idUz, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano dostęp', "", 3000)
                    this.pobierzUzytkownikow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji dostępu', "", 3000)
                }
            }.bind(this))
        }
        else {
            UzytownicyService.addUzytkownik(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano dostęp', "", 3000)
                    this.pobierzUzytkownikow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania dostępu', "", 3000)
                }
            }.bind(this))
        }

        this.onZakmnijForm()
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc użytkownika: ' + obj.login)) {
            UzytownicyService.deleteUzytkownik(obj.idUz).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto dostęp', "", 3000)
                    this.pobierzUzytkownikow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania dostępu', "", 3000)
                }
            }.bind(this))

        }
    }

    onZakmnijForm() {
        this.setState({
            pokazFormularz: false,
            pokazFormularzHaslo: false,
            user: null
        })
    }

    onClickZmienHaslo(obj) {
        this.setState({
            pokazFormularzHaslo: true,
            user: obj
        })
    }

    onClickZapiszHaslo(obj) {

        UzytownicyService.zmienHasloUzytkowikowi(obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono hasło dostępu', "", 3000)

                if (obj.idUz === LogowanieService.pobierzZalogowanego().idUz) {
                    let user = LogowanieService.pobierzZalogowanego();
                    user.token = 'Basic ' + btoa(user.login + ':' + obj.newPassword)
                    localStorage.removeItem('obecnyUserMacelApp');
                    LogowanieService.zalogujUzytkownika(user, 'Basic ' + btoa(user.login + ':' + obj.newPassword))
                }

                this.pobierzUzytkownikow();
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany hasła dostępu', "", 3000)
            }
            this.onZakmnijForm();
        }.bind(this))

    }

    onSizePerPageList = (ilosc) => {
        this.setState({ilosc})
    }

    onPageChange = (page, sizePerPage) => {
        this.setState({strona: page})
        this.pobierzUzytkownikow(page, sizePerPage)
    }


    onChangeTypPracownika = (obj) => {

        this.setState({szukanyTyp: obj, strona: 1})
        this.pobierzUzytkownikow(1, this.state.ilosc, this.state.szukanyCiag, obj)

    }

    onChangeLogin = ({target: {value}}) => {
        this.setState({
            szukanyCiag: value,
            strona: 1
        })

        if (Boolean(this.state.szukanyTyp) && value.length > 2) {
            this.pobierzUzytkownikow(1, this.state.ilosc, value, this.state.szukanyTyp)
        }
        else if (value.length === 0) {
            this.pobierzUzytkownikow(1, this.state.ilosc, '', this.state.szukanyTyp)
        }

    }

    onWyczyscSzukanie = () => {

        document.getElementById('input_login').value = ''

        this.setState({
            strona: 1,
            szukanyCiag: '',
            szukanyTyp: null
        })
        this.pobierzUzytkownikow(1, this.state.ilosc, '', null)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <ReactNotify ref='notificator'/>
                <Grid fluid={true} id={'AdministracjaContainer'}>
                    <TopIf isTrue={this.state.trwaSzukanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa szukanie rekordów...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/dostep',
                                    text: 'Dostęp'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={8}>
                            <Form inline={true}>
                                <FormGroup style={{width: "200px"}}>
                                    <ControlLabel>
                                        Typ użytkownika
                                    </ControlLabel>
                                    <TopSelect onChange={this.onChangeTypPracownika}
                                               value={this.state.szukanyTyp}
                                               options={[
                                                   {value: 'PRACOWNIK', label: "Pracownik"},
                                                   {value: 'KIEROWCA', label: "Kierowca"},
                                                   {value: 'KLIENT', label: "Klient"},
                                               ]}
                                               clearable={true}
                                    />
                                </FormGroup>
                                <FormGroup style={{width: '300px', margin: '0 15px'}}>
                                    <ControlLabel>
                                        Login
                                    </ControlLabel>
                                    <div>
                                        <FormControl
                                            style={{width: '300px'}}
                                            onChange={this.onChangeLogin}
                                            id={'input_login'}
                                            placeholder={"Login, minimum 3 znaki"}
                                        />
                                    </div>
                                </FormGroup>
                                <FormGroup>
                                    <div className={'add-label-margin'}></div>
                                    {
                                        (Boolean(this.state.szukanyTyp) || this.state.szukanyCiag.length > 0) &&
                                        <div onClick={this.onWyczyscSzukanie}
                                             style={{color: "firebrick", fontSize: "12px", cursor: "pointer"}}
                                        ><i
                                            className={'fa fa-eraser'}></i> Wyczyść</div>
                                    }
                                </FormGroup>
                            </Form>
                            <TopAlertInformacja
                                text={'Aby użyć narzędzia wyszukiwania, należy wybrać typ użytkownika oraz opcjonalnie wpisać login'}/>
                        </Col>
                        <Col sm={4}>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true});
                                        ScrollUtilities.scrollToTop()
                                    }} text={'Dodaj dostęp'}/>
                                </div>
                            </TopIf>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <DostepForm handleClickAnuluj={this.onZakmnijForm}
                                            handleZapisz={this.onClickZapisz}
                                            user={this.state.user}
                                            role={this.state.role}
                                            kierowcy={this.state.kierowcy}
                                            pracownicy={this.state.pracownicy}
                                />
                            </TopIf>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={this.state.pokazFormularzHaslo}>
                                <DostepPasswordForm handleClickAnuluj={this.onZakmnijForm} handleZmienHaslo={this.onClickZapiszHaslo}
                                                    user={this.state.user}/>
                            </TopIf>
                        </Col>
                        <Col sm={12}>
                            <DostepTable history={this.props.history}
                                         data={this.state.uzytkownicy}
                                         kierowcy={this.state.kierowcy}
                                         pracownicy={this.state.pracownicy}

                                         pageable={this.state.pageable}
                                         ilosc={this.state.ilosc}
                                         strona={this.state.strona}
                                         onSizePerPageList={this.onSizePerPageList}
                                         onPageChange={this.onPageChange}

                                         handleEdytuj={this.onClickEdytuj}
                                         handleUsun={this.onClickUsun}
                                         wlaczSzukanie={true}
                                         handleZmienHaslo={this.onClickZmienHaslo}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/dostep/DostepContainer.js